import { Box, Grid, IconButton, Typography, useTheme } from "@mui/material";
import React, { FC, useEffect } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import { useActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";

import AnnouncementItem from "../../../components/AnnouncementItem";
import LinkRouter from "../../../components/LinkRouter";

const AnnouncementsSimilar: FC<{ urlSlug: string | undefined }> = ({ urlSlug }) => {
    const { palette } = useTheme();

    const { GetSimilar } = useActions();
    const { announcements } = useTypedSelector((store) => store.announcementUser);

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            if (urlSlug !== undefined)
                await GetSimilar(false, urlSlug);
        } catch (ex) {
        }
    };

    return (
        <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: "109px", mb: "35px" }}>
                <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold">
                    Анонси
                </Typography>
                <LinkRouter underline="none" color="text.secondary" to={"/announcements"}>
                    <Typography fontSize="16px" lineHeight="24px" fontFamily="Fixel Display, sans-serif" fontWeight="600">
                        Більше...
                    </Typography>
                </LinkRouter>
            </Box>
            <Box sx={{ height: "392px", position: "relative" }}>
                <Swiper
                    modules={[Pagination, Navigation]}
                    pagination={{
                        type: "progressbar",
                        el: '.custom-pagination',
                    }}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        disabledClass: "disabled-cursor"
                    }}
                    slidesPerView={4}
                    slidesPerGroup={1}
                    spaceBetween={24}
                    style={{ height: "348px", paddingLeft: "0px", paddingRight: "36px" }}
                >
                    {announcements.map((item, index) => {
                        return (
                            <SwiperSlide key={`swiper_${item.urlSlug}`} >
                                <AnnouncementItem isProject={false} urlSlug={item.urlSlug} title={item.title} description={item.description} imagePreview={item.imagePreview} date={item.date} announcementTime={item.announcementTime} hashtags={item.hashtags} />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                <Box sx={{ width: "100%", display: "flex", position: "absolute", left: "0px", bottom: "0px", height: "44px" }}>
                    <Box
                        className="custom-pagination"
                        sx={{
                            width: "1152px !important",
                            height: "5px !important",
                            background: `#3C3C47 !important`,
                            borderRadius: "4px !important",
                            "& .swiper-pagination-progressbar-fill": {
                                background: `${palette.primary.main} !important`,
                                borderRadius: "4px !important",
                            },
                            mt: "20px",
                            ml: "54px"
                        }}
                    />
                    <Box className="swiper-button-prev" sx={{ right: "52px !important", left: "unset !important", top: "35% !important" }} />
                    <Box className="swiper-button-next" sx={{ right: "12px !important", top: "35% !important" }} />
                </Box>
            </Box>
        </Grid>
    );
};

export default AnnouncementsSimilar;
